<template>
  <div class="input" :class="wrapperClasses">
    <div v-if="label" class="mb-2">
      <label :for="name">
        {{ label }}
      </label>
      <slot></slot>
    </div>

    <div v-if="copy" class="copy">
      <p>
        {{ copy }}
      </p>
    </div>

    <input
      :id="name"
      v-model="model"
      class="input__field input__field--text"
      :class="{
        'input__field--inverted': inverted,
        'input__field--error': error,
      }"
      :disabled="disabled"
      :maxlength="mapping.attributes && mapping.attributes.maxLength"
      :placeholder="placeholder"
      type="text"
      @blur="onBlur"
      @focus="onFocus"
    ></input>

    <div
      v-if="mapping.attributes && mapping.attributes.maxLength"
      class="input__remaining"
      :class="{ 'input__remaining--warning': charactersLeft < 10 }"
    >
      {{ $t('images.upload.imageDescription.characters', { charactersLeft }) }}
    </div>
  </div>
</template>

<script>

export default {
    name: 'image-description',

    props: {
        value: {
            type: String,
            default: null,
        },

        copy: {
            type: String,
            default: null,
        },

        mapping: {
            type: Object,
            default: () => {
                return {};
            },
        },

        inverted: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        error: {
            type: Boolean,
            default: false,
        },

        label: {
            type: String,
            default: null,
        },

        name: {
            type: String,
            default: null,
        },

        placeholder: {
            type: String,
            default: null,
        }
    },

    data() {
        return {
            hasFocus: false,
        };
    },

    computed: {
        model: {
            get() {
                return this.value || '';
            },
            set(value) {
                if(value === '') value = null;
                this.$emit('input', value);
            },
        },

        attributes() {
            return { ...this.mapping.attributes };
        },

        charactersLeft() {
            return this.mapping.attributes.maxLength - ((this.model && this.model.length) || 0);
        },

        wrapperClasses() {
            return {
                'input--error': this.errors && this.errors.length > 0,
                'input--filled': this.model && (this.model.length > 0 || Number.isInteger(this.model)),
                'input--focused': this.hasFocus,
            };
        },
    },

    methods: {
        onBlur() {
            this.hasFocus = false;
            this.$emit('blur');
        },

        onFocus() {
            this.hasFocus = true;
            this.$emit('focus');
        },
    },
};
</script>

<style lang="scss">
@import "image-description.scss";
</style>



// WEBPACK FOOTER //
// src/views/components/campsite-images/image-description.vue